import {
  FETCH_BILLING_PLANS,
  FETCH_BILLING_PLANS_ERROR,
  CLEAR_FETCH_BILLING_PLANS,
  FETCH_STRIPE_SETUP_INTENT,
  FETCH_STRIPE_SETUP_INTENT_ERROR,
  CLEAR_STRIPE_SETUP_INTENT,
  UPDATE_BILLING_PLAN,
  UPDATE_BILLING_PLAN_ERROR,
  CLEAR_UPDATE_BILLING_PLAN,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_ERROR,
  CLEAR_CANCEL_SUBSCRIPTION,
  RENEW_SUBSCRIPTION,
  RENEW_SUBSCRIPTION_ERROR,
  CLEAR_RENEW_SUBSCRIPTION,
  FETCH_CREDIT_CARD_INFO,
  FETCH_CREDIT_CARD_INFO_ERROR,
  CLEAR_FETCH_CREDIT_CARD_INFO,
  UPDATE_CREDIT_CARD,
  UPDATE_CREDIT_CARD_ERROR,
  CLEAR_UPDATE_CREDIT_CARD,
  VALIDATE_STRIPE_COUPON_SUCCES,
  VALIDATE_STRIPE_COUPON_ERROR,
  CLEAR_VALIDATE_STRIPE_COUPON,
  SET_BILLING_PLAN_SELECTOR_MODE,
  FETCH_BILLING_INVOICES,
  FETCH_BILLING_INVOICES_ERROR,
  CLEAR_FETCH_BILLING_INVOICES,
  FETCH_SINGLE_INVOICE_PDF,
  FETCH_SINGLE_INVOICE_PDF_ERROR,
  CLEAR_FETCH_SINGLE_INVOICE_PDF,
  FETCH_BILLING_INFO,
  FETCH_BILLING_INFO_ERROR,
  CLEAR_FETCH_BILLING_INFO,
  PATCH_BILLING_INFO_SUCCESS,
  PATCH_BILLING_INFO_ERROR,
  CLEAR_PATCH_BILLING_INFO,
  UPDATE_BILLING_PLAN_PAYPAL,
  UPDATE_BILLING_PLAN_PAYPAL_ERROR,
  CLEAR_UPDATE_BILLING_PLAN_PAYPAL,
  UPDATE_BILLING_PLAN_CRYPTOCOM,
  UPDATE_BILLING_PLAN_CRYPTOCOM_ERROR,
  CLEAR_UPDATE_BILLING_PLAN_CRYPTOCOM,
  DELETE_PAYMENT_PROVIDER_SUCCESS,
  DELETE_PAYMENT_PROVIDER_ERROR,
  CLEAR_DELETE_PAYMENT_PROVIDER,
  PATCH_PAYMENT_PROVIDER_SUCCESS,
  PATCH_PAYMENT_PROVIDER_ERROR,
  CLEAR_PATCH_PAYMENT_PROVIDER,
  FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK,
  FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK_ERROR,
  CLEAR_PAYMENT_PROVIDER_ONBOARDING_LINK,
} from 'redux/billing/types';

const initialState = {
  billingPlans: null,
  billingPlansError: null,
  stripeSetupIntent: null,
  stripeSetupIntentError: null,
  userBillingPlanUpdated: false,
  userBillingPlanUpdateError: null,
  userBillingPlanUpdatedPaypal: false,
  userBillingPlanUpdatePaypalError: null,
  userBillingPlanUpdatedCryptocom: false,
  userBillingPlanUpdateCryptocomError: null,
  subscriptionCancelled: null,
  subscriptionCancelledError: null,
  subscriptionRenewed: null,
  subscriptionRenewedError: null,
  creditCardInfo: null,
  creditCardInfoError: null,
  creditCardUpdated: null,
  creditCardUpdateError: null,
  stripeCouponSuccess: null,
  stripeCouponError: null,
  billingPlanSelectorMode: 'month',
  billingInvoices: null,
  billingInvoicesError: null,
  singleInvoicePdf: null,
  singleInvoicePdfError: null,
  billingInfo: null,
  billingInfoError: null,
  patchBillingInfoSuccess: null,
  patchBillingInfoError: null,
  deletePaymentProviderSuccess: null,
  deletePaymentProviderError: null,
  patchPaymentProviderSuccess: null,
  patchPaymentProviderError: null,
  paymentProviderOnboardingLink: null,
  paymentProviderOnboardingLinkError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BILLING_PLANS:
      return {
        ...state,
        billingPlans: action.payload.data,
        billingPlansError: null,
      };
    case FETCH_BILLING_PLANS_ERROR:
      return {
        ...state,
        billingPlans: null,
        billingPlansError: action.payload.data,
      };
    case CLEAR_FETCH_BILLING_PLANS:
      return {
        ...state,
        billingPlans: null,
        billingPlansError: null,
      };
    case FETCH_STRIPE_SETUP_INTENT:
      return {
        ...state,
        stripeSetupIntent: action.payload.data,
        stripeSetupIntentError: null,
      };
    case FETCH_STRIPE_SETUP_INTENT_ERROR:
      return {
        ...state,
        stripeSetupIntent: null,
        stripeSetupIntentError: action.payload.data,
      };
    case CLEAR_STRIPE_SETUP_INTENT:
      return {
        ...state,
        stripeSetupIntent: null,
        stripeSetupIntentError: null,
      };
    case UPDATE_BILLING_PLAN:
      return {
        ...state,
        userBillingPlanUpdated: true,
        userBillingPlanUpdateError: null,
      };
    case UPDATE_BILLING_PLAN_ERROR:
      return {
        ...state,
        userBillingPlanUpdated: null,
        userBillingPlanUpdateError: action.payload.data,
      };
    case CLEAR_UPDATE_BILLING_PLAN:
      return {
        ...state,
        userBillingPlanUpdated: false,
        userBillingPlanUpdateError: null,
      };
    case UPDATE_BILLING_PLAN_PAYPAL:
      return {
        ...state,
        userBillingPlanUpdatedPaypal: true,
        userBillingPlanUpdatedPaypalError: null,
      };
    case UPDATE_BILLING_PLAN_PAYPAL_ERROR:
      return {
        ...state,
        userBillingPlanUpdatedPaypal: null,
        userBillingPlanUpdatedPaypalError: action.payload.data,
      };
    case CLEAR_UPDATE_BILLING_PLAN_PAYPAL:
      return {
        ...state,
        userBillingPlanUpdatedPaypal: false,
        userBillingPlanUpdatedPaypalError: null,
      };
    case UPDATE_BILLING_PLAN_CRYPTOCOM:
      return {
        ...state,
        userBillingPlanUpdatedCryptocom: true,
        userBillingPlanUpdatedCryptocomError: null,
      };
    case UPDATE_BILLING_PLAN_CRYPTOCOM_ERROR:
      return {
        ...state,
        userBillingPlanUpdatedCryptocom: null,
        userBillingPlanUpdatedCryptocomError: action.payload.data,
      };
    case CLEAR_UPDATE_BILLING_PLAN_CRYPTOCOM:
      return {
        ...state,
        userBillingPlanUpdatedCryptocom: false,
        userBillingPlanUpdatedCryptocomError: null,
      };
    case CANCEL_SUBSCRIPTION:
      return {
        ...state,
        subscriptionCancelled: action.payload.data,
        subscriptionCancelledError: null,
      };
    case CANCEL_SUBSCRIPTION_ERROR:
      return {
        ...state,
        subscriptionCancelled: null,
        subscriptionCancelledError: action.payload.data,
      };
    case CLEAR_CANCEL_SUBSCRIPTION:
      return {
        ...state,
        subscriptionCancelled: null,
        subscriptionCancelledError: null,
      };
    case RENEW_SUBSCRIPTION:
      return {
        ...state,
        subscriptionRenewed: action.payload.data,
        subscriptionRenewedError: null,
      };
    case RENEW_SUBSCRIPTION_ERROR:
      return {
        ...state,
        subscriptionRenewed: null,
        subscriptionRenewedError: action.payload.data,
      };
    case CLEAR_RENEW_SUBSCRIPTION:
      return {
        ...state,
        subscriptionRenewed: null,
        subscriptionRenewedError: null,
      };
    case FETCH_CREDIT_CARD_INFO:
      return {
        ...state,
        creditCardInfo: action.payload.data,
        creditCardInfoError: null,
      };
    case FETCH_CREDIT_CARD_INFO_ERROR:
      return {
        ...state,
        creditCardInfo: null,
        creditCardInfoError: action.payload.data,
      };
    case CLEAR_FETCH_CREDIT_CARD_INFO:
      return {
        ...state,
        creditCardInfo: null,
        creditCardInfoError: null,
      };
    case UPDATE_CREDIT_CARD:
      return {
        ...state,
        creditCardUpdated: action.payload.data,
        creditCardUpdateError: null,
      };
    case UPDATE_CREDIT_CARD_ERROR:
      return {
        ...state,
        creditCardUpdated: null,
        creditCardUpdateError: action.payload.data,
      };
    case CLEAR_UPDATE_CREDIT_CARD:
      return {
        ...state,
        creditCardUpdated: null,
        creditCardUpdateError: null,
      };
    case VALIDATE_STRIPE_COUPON_SUCCES:
      return {
        ...state,
        stripeCouponSuccess: action.payload.data,
        stripeCouponError: null,
      };
    case VALIDATE_STRIPE_COUPON_ERROR:
      return {
        ...state,
        stripeCouponSuccess: null,
        stripeCouponError: action.payload.data,
      };
    case CLEAR_VALIDATE_STRIPE_COUPON:
      return {
        ...state,
        stripeCouponSuccess: null,
        stripeCouponError: null,
      };
    case SET_BILLING_PLAN_SELECTOR_MODE:
      return {
        ...state,
        billingPlanSelectorMode: action.payload.data,
      };
    case FETCH_BILLING_INVOICES:
      return {
        ...state,
        billingInvoices: action.payload.data,
        billingInvoicesError: null,
      };
    case FETCH_BILLING_INVOICES_ERROR:
      return {
        ...state,
        billingInvoices: null,
        billingInvoicesError: action.payload.data,
      };
    case CLEAR_FETCH_BILLING_INVOICES:
      return {
        ...state,
        billingInvoices: null,
        billingInvoicesError: null,
      };
    case FETCH_SINGLE_INVOICE_PDF:
      return {
        ...state,
        singleInvoicePdf: action.payload.data,
        singleInvoicePdfError: null,
      };
    case FETCH_SINGLE_INVOICE_PDF_ERROR:
      return {
        ...state,
        singleInvoicePdf: null,
        singleInvoicePdfError: action.payload.data,
      };
    case CLEAR_FETCH_SINGLE_INVOICE_PDF:
      return {
        ...state,
        singleInvoicePdf: null,
        singleInvoicePdfError: null,
      };
    case FETCH_BILLING_INFO:
      return {
        ...state,
        billingInfo: action.payload.data,
        billingInfoError: null,
      };
    case FETCH_BILLING_INFO_ERROR:
      return {
        ...state,
        billingInfo: null,
        billingInfoError: action.payload.data,
      };
    case CLEAR_FETCH_BILLING_INFO:
      return {
        ...state,
        billingInfo: null,
        billingInfoError: null,
      };
    case PATCH_BILLING_INFO_SUCCESS:
      return {
        ...state,
        patchBillingInfoSuccess: action.payload.data,
        patchBillingInfoError: null,
      };
    case PATCH_BILLING_INFO_ERROR:
      return {
        ...state,
        patchBillingInfoSuccess: null,
        patchBillingInfoError: action.payload.data,
      };
    case CLEAR_PATCH_BILLING_INFO:
      return {
        ...state,
        patchBillingInfoSuccess: null,
        patchBillingInfoError: null,
      };
    case DELETE_PAYMENT_PROVIDER_SUCCESS:
      return {
        ...state,
        deletePaymentProviderSuccess: action.payload.data,
        deletePaymentProviderError: null,
      };
    case DELETE_PAYMENT_PROVIDER_ERROR:
      return {
        ...state,
        deletePaymentProviderSuccess: null,
        deletePaymentProviderError: action.payload.data,
      };
    case CLEAR_DELETE_PAYMENT_PROVIDER:
      return {
        ...state,
        deletePaymentProviderSuccess: null,
        deletePaymentProviderError: null,
      };

    case PATCH_PAYMENT_PROVIDER_SUCCESS:
      return {
        ...state,
        patchPaymentProviderSuccess: action.payload.data,
        patchPaymentProviderError: null,
      };
    case PATCH_PAYMENT_PROVIDER_ERROR:
      return {
        ...state,
        patchPaymentProviderSuccess: null,
        patchPaymentProviderError: action.payload.data,
      };
    case CLEAR_PATCH_PAYMENT_PROVIDER:
      return {
        ...state,
        patchPaymentProviderSuccess: null,
        patchPaymentProviderError: null,
      };

    case FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK:
      return {
        ...state,
        paymentProviderOnboardingLink: action.payload.data,
        paymentProviderOnboardingLinkError: null,
      };
    case FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK_ERROR:
      return {
        ...state,
        paymentProviderOnboardingLink: null,
        paymentProviderOnboardingLinkError: action.payload.data,
      };
    case CLEAR_PAYMENT_PROVIDER_ONBOARDING_LINK:
      return {
        ...state,
        paymentProviderOnboardingLink: null,
        paymentProviderOnboardingLinkError: null,
      };

    default:
      return state;
  }
};
